import {SET_EVITE_EVENT} from '~/CreateFabricGreetingCard/reducers/eviteEvent/constants';
import {Sections} from '~/common/FabricInvitation/EventCreateDesign/constants';
import {INIT_APP} from '~/common/fabric/constants';
import {
  fabricArtWithHttpsForAllImgPaths,
  fabricDesignWithCrossOriginUpdates,
} from '~/common/utils/event_utils';
import {silver} from '~libSass/base/_exports.sass';
import {UPDATE_DESIGN_OPTIONS} from './constants';

const initialState = {
  originalFabricArt: {},
  fabricArt: {},
  backgroundId: null,
  backgroundColor: silver,
  stampId: 'evite01',
  envelopeId: 'wht01',
  linerId: '',
  envelopeStickers: null,
  currentSection: Sections.CARD_DESIGN,
  loaded: false,
  touched: false,
  pristine: true,
  hasTextbox: true,
  editingMobile: false,
  editingUyoMobile: false,
  textAreaOpen: false,
  savingStep: false,
  forceShowOnboardingModal: false,
  uyoImagePath: '',
  isGiphy: false,
  shouldUseCachedGalleryPhoto: false,
};

function firstMatchingArt(art, categoryList) {
  const updatedArt = fabricArtWithHttpsForAllImgPaths(art);
  for (const c of categoryList) if (c && updatedArt[c]) return updatedArt[c];
  return undefined;
}

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case UPDATE_DESIGN_OPTIONS:
      return {...state, ...action.payload};
    case SET_EVITE_EVENT: {
      const eviteEvent = action.payload;
      return {
        ...state,
        fabricArt: fabricDesignWithCrossOriginUpdates(eviteEvent?.fabric_design_data),
        pristine: false,
      };
    }
    case INIT_APP: {
      const template = action.payload.template || {};
      const event = action.payload.event || {};
      const design = event?.options?.design;
      const templateEditableArt = fabricArtWithHttpsForAllImgPaths(template?.editable_art);

      return {
        ...state,
        originalFabricArt: firstMatchingArt(templateEditableArt, [
          event?.event_type,
          action.payload.category_event_type,
          template.event_type,
          'default',
        ]),

        fabricArt:
          fabricDesignWithCrossOriginUpdates(event?.fabric_design_data) ??
          firstMatchingArt(templateEditableArt, [
            action.payload.category_event_type,
            template.event_type,
            'default',
          ]),
        backgroundId: design?.background ?? template?.backgrounds?.[0],
        backgroundColor: design?.background_color ?? template?.background_color ?? silver,
        stampId: design?.stamp ?? template?.stamps?.[0],
        envelopeId: design?.envelope ?? template?.envelopes?.[0],
        linerId: design?.liner ?? template?.liners?.[0],
        currentSection: Sections.CARD_DESIGN,
        envelopeStickers: design?.envelope_fabric_stickers,
        loaded: false,
        touched: !!event?.id,
        pristine: !event?.id,
        premiumFeaturesPristine: !event?.id,
        premiumFeaturesWarning: false,
        ignorePremiumWarning: !!event?.id,
        editingMobile: false,
        editorDisabled: !!event?.id,
        forceShowOnboardingModal: false,
        shouldUseCachedGalleryPhoto: false,
      };
    }
    default:
      return state;
  }
};
